import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Workshop } from 'src/models/workshop';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';

import { APIServiceDealer } from 'src/services/api-services/api-service-dealer';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';

import { WorkshopsComponent } from '../../workshops.component';
import { HelperService } from '../../../../../services/helperService';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-workshop',
    templateUrl: './delete-workshop.dialog.html',
    styleUrls: ['./delete-workshop.dialog.sass'],
    standalone: false
})
export class DeleteWorkshopDialog {
  constructor(

    public dialogRef: MatDialogRef<WorkshopsComponent>,
    @Inject(MAT_DIALOG_DATA) public workshop: Workshop,
    public WorkshopService: APIWorkshopService,
    public ServiceDealer: APIServiceDealer,
    public dealerBlockedService: APIDealerBlockedServices,
    public helperService: HelperService,
    private translate: TranslateService
   ) {}


  isError = false;
  eventReassignment: string = '';
  serviceDealer: any;
  data_save: any;

  ngOnInit(): void {
  }

  // this.HelperService.user.language
  // Disable a workshop
  onSaveDisable(): void { //
    if (this.workshop.isActive === true) {
      this.workshop.isActive = false;
    }
    if (this.workshop.email === '') {
      this.workshop.email = this.workshop.workshopName + '@';
    }
    this.WorkshopService?.put(this.workshop)
      .pipe(
        finalize(() => {
          this.dialogRef.close('DeleteData');
          const translateText = this.translate.instant(
            'ToastWorkshopDisabled',
            {
              fullName:this.workshop.workshopName,
            }
          );
          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateText

          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)
        })
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.isError = true;

  }
}
